import { render } from "./ExamEditPriview.vue?vue&type=template&id=4e4e3160&scoped=true"
import script from "./ExamEditPriview.vue?vue&type=script&lang=js"
export * from "./ExamEditPriview.vue?vue&type=script&lang=js"

import "./ExamEditPriview.vue?vue&type=style&index=0&id=4e4e3160&lang=less&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4e3160"]])

export default __exports__